export default __webpack_public_path__ + "static/media/EM0333.34I-41664_-24929_0.2fbb5ff2.jpg";